'use strict';
var parent = require('../../actual/instance/index-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/instance/index-of.js
// module id = 622
// module chunks = 13